// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { AppDispatch, RootState } from 'app/store';
// import {
//   fetchManagers,
//   clearManagers
// } from '../../slices/NdisSlices/managersList/ManagersListSlice';
// import { Manager } from '../../types/ndisSection/managersListTypes';
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Modal,
//   Typography,
//   useMediaQuery
// } from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import {
//   DataGrid,
//   GridColDef,
//   GridPaginationModel,
//   GridToolbarQuickFilter
// } from '@mui/x-data-grid';
// import { Message } from '@mui/icons-material';
// import { useClientContext } from './ProfileMainPage';
// import axiosInstance from 'Services/APIService';

// // Dynamic Columns based on screen size
// const getColumns = (isMobile: boolean): GridColDef[] => [
//   {
//     field: 'avatar',
//     headerName: isMobile ? '' : 'Image',
//     width: isMobile ? 50 : 80,
//     renderCell: (params) => (
//       <Avatar
//         src={params.row.avatarUrl}
//         alt={params.row.name}
//         sx={{
//           width: isMobile ? 32 : 40,
//           height: isMobile ? 32 : 40
//         }}
//       />
//     ),
//     sortable: false,
//     filterable: false,
//     hideable: isMobile
//   },
//   {
//     field: 'name',
//     headerName: 'Name',
//     flex: isMobile ? 1 : 2,
//     minWidth: isMobile ? 120 : 150,
//     sortable: true
//   },
//   {
//     field: 'email',
//     headerName: isMobile ? '' : 'Email',
//     flex: isMobile ? 0 : 2,
//     minWidth: isMobile ? 0 : 180,
//     sortable: !isMobile,
//     hideable: isMobile
//   },
//   {
//     field: 'message',
//     headerName: isMobile ? '' : 'Message',
//     flex: isMobile ? 1 : 1,
//     minWidth: isMobile ? 80 : 180,
//     renderCell: (params) => (
//       <Button
//         variant="outlined"
//         color="primary"
//         startIcon={isMobile ? null : <Message />}
//         size={isMobile ? 'small' : 'medium'}
//         sx={{
//           textTransform: 'none',
//           fontSize: isMobile ? '0.75rem' : '0.875rem',
//           minWidth: isMobile ? 60 : 'auto',
//           padding: isMobile ? '4px 8px' : '6px 16px'
//         }}
//         onClick={() => params.row.handleMessageClick(params.row)}
//       >
//         {isMobile ? 'Msg' : 'Message'}
//       </Button>
//     ),
//     sortable: false,
//     filterable: false
//   }
// ];

// // Responsive Toolbar
// function CustomToolbar({ isMobile }: { isMobile: boolean }) {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 1,
//         p: 1,
//         bgcolor: 'background.paper',
//         borderBottom: '1px solid #e0e0e0'
//       }}
//     >
//       <Typography
//         variant={isMobile ? 'subtitle1' : 'h6'}
//         sx={{
//           fontWeight: 'bold',
//           textAlign: 'center',
//           fontSize: isMobile ? '1rem' : '1.25rem'
//         }}
//       >
//         Office Support Directory
//       </Typography>
//       <Box sx={{ width: '100%' }}>
//         <GridToolbarQuickFilter
//           placeholder={isMobile ? 'Search...' : 'Search office support...'}
//           debounceMs={500}
//           quickFilterParser={(value) => value.split(' ')}
//           sx={{
//             width: '100%',
//             '& .MuiInputBase-root': {
//               borderRadius: '4px',
//               paddingLeft: '12px',
//               bgcolor: '#f4f4f4',
//               border: '1px solid #d6d6d6',
//               height: isMobile ? '36px' : 'auto'
//             },
//             '& .MuiInputBase-input': {
//               fontSize: isMobile ? '0.875rem' : '1rem'
//             }
//           }}
//         />
//       </Box>
//     </Box>
//   );
// }

// const OfficeSupport: React.FC = () => {
//   const dispatch = useDispatch<AppDispatch>();
//   const { selectedClient } = useClientContext();
//   const isMobile = useMediaQuery('(max-width:600px)');
//   const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
//     page: 0,
//     pageSize: isMobile ? 5 : 10
//   });
//   const [messageModalOpen, setMessageModalOpen] = useState(false);
//   const [selectedWorker, setSelectedWorker] = useState<Manager | null>(null);
//   const [avatarUrls, setAvatarUrls] = useState<{ [key: string]: string | null }>({});

//   // Redux state
//   const officeSupport = useSelector(
//     (state: RootState) => state.managersList.fullStaff?.participants_list['Office support'] || []
//   );
//   const loading = useSelector((state: RootState) => state.managersList.loading);
//   const error = useSelector((state: RootState) => state.managersList.error);
//   const selectedProjectId = useSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const userDetails = localStorage.getItem('user-details');
//   const parsedUserDetails = userDetails ? JSON.parse(userDetails) : null;
//   const email = parsedUserDetails?.email || '';
//   const roles = parsedUserDetails?.role ? [parsedUserDetails.role] : [''];

//   // Fetch avatars for all office support workers
//   useEffect(() => {
//     const fetchAvatars = async () => {
//       const newAvatarUrls: { [key: string]: string | null } = {};
//       for (const worker of officeSupport) {
//         if (worker.avartar) {
//           try {
//             const response = await axiosInstance.get(
//               `/avatar/get-avatar?path=${encodeURIComponent(worker.avartar)}`,
//               { responseType: 'blob' }
//             );
//             const imageUrl = URL.createObjectURL(response.data);
//             newAvatarUrls[worker.id] = imageUrl;
//           } catch (error) {
//             console.error(`Error fetching avatar for ${worker.name}:`, error);
//             newAvatarUrls[worker.id] = null;
//           }
//         } else {
//           newAvatarUrls[worker.id] = null;
//         }
//       }
//       setAvatarUrls(newAvatarUrls);
//     };

//     if (officeSupport.length > 0) {
//       fetchAvatars();
//     }

//     // Cleanup object URLs to prevent memory leaks
//     return () => {
//       Object.values(avatarUrls).forEach((url) => {
//         if (url) {
//           URL.revokeObjectURL(url);
//         }
//       });
//     };
//   }, [officeSupport]);

//   const handleMessageClick = (worker: Manager) => {
//     setSelectedWorker(worker);
//     setMessageModalOpen(true);
//   };

//   const closeModals = () => {
//     setMessageModalOpen(false);
//     setSelectedWorker(null);
//   };

//   // Fetch data when dependencies change
//   useEffect(() => {
//     if (selectedClient && selectedProjectId && selectedServiceTitle && email && roles.length > 0) {
//       const payload = {
//         group_id: selectedProjectId,
//         service_name_id: selectedServiceTitle,
//         nested_component_id: 'Office Support',
//         email,
//         roles,
//         client_name: selectedClient.label
//       };
//       dispatch(fetchManagers(payload));
//     }
//     return () => {
//       dispatch(clearManagers());
//     };
//   }, [selectedClient?.label]);

//   // Prepare rows with avatar URLs and handler function
//   const rows = officeSupport.map((worker) => ({
//     ...worker,
//     avatarUrl: avatarUrls[worker.id] || null,
//     handleMessageClick
//   }));

//   const theme = createTheme({
//     palette: {
//       primary: { main: '#2196f3' },
//       background: { default: '#f5f5f5', paper: '#ffffff' }
//     },
//     typography: {
//       fontFamily: 'Roboto, Arial',
//       fontSize: isMobile ? 12 : 14
//     },
//     components: {
//       MuiButton: {
//         defaultProps: {
//           size: isMobile ? 'small' : 'medium'
//         }
//       }
//     }
//   });

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: isMobile ? 'calc(100vh - 120px)' : 700,
//           width: '100%',
//           bgcolor: 'background.default',
//           p: isMobile ? 1 : 3,
//           borderRadius: 2,
//           boxShadow: 1,
//           overflow: 'hidden'
//         }}
//       >
//         {loading && (
//           <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//             <CircularProgress size={isMobile ? 24 : 40} />
//           </Box>
//         )}
//         {error && (
//           <Alert severity="error" sx={{ mb: 2, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
//             {error}
//           </Alert>
//         )}
//         {!selectedClient && (
//           <Alert severity="warning" sx={{ mb: 2, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
//             Please select a client to view office support.
//           </Alert>
//         )}
//         {selectedClient && !loading && !error && (
//           <DataGrid
//             rows={rows}
//             columns={getColumns(isMobile)}
//             getRowId={(row) => row.id}
//             components={{ Toolbar: () => <CustomToolbar isMobile={isMobile} /> }}
//             checkboxSelection={false}
//             pagination
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={isMobile ? [5, 10] : [10, 25, 50]}
//             sx={{
//               '& .MuiDataGrid-columnHeaders': {
//                 bgcolor: '#f4f4f4',
//                 color: '#333',
//                 fontSize: isMobile ? '0.75rem' : '0.875rem',
//                 fontWeight: 'bold'
//               },
//               '& .MuiDataGrid-row:nth-of-type(odd)': {
//                 bgcolor: '#fafafa'
//               },
//               '& .MuiDataGrid-row:nth-of-type(even)': {
//                 bgcolor: '#ffffff'
//               },
//               '& .MuiDataGrid-row:hover': {
//                 bgcolor: '#e3f2fd'
//               },
//               '& .MuiDataGrid-cell': {
//                 fontSize: isMobile ? '0.75rem' : '0.875rem',
//                 padding: isMobile ? '4px 8px' : '8px 16px'
//               },
//               '& .MuiDataGrid-footerContainer': {
//                 bgcolor: '#f4f4f4',
//                 borderTop: '1px solid #e0e0e0',
//                 '& .MuiTablePagination-root': {
//                   fontSize: isMobile ? '0.75rem' : '0.875rem'
//                 }
//               },
//               '& .MuiDataGrid-virtualScroller': {
//                 overflowX: 'hidden'
//               }
//             }}
//           />
//         )}
//       </Box>

//       <Modal
//         open={messageModalOpen}
//         onClose={closeModals}
//         aria-labelledby="message-modal-title"
//         aria-describedby="message-modal-description"
//       >
//         <Box
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: isMobile ? '90%' : 400,
//             bgcolor: 'background.paper',
//             p: isMobile ? 2 : 4,
//             boxShadow: 24,
//             borderRadius: 2,
//             outline: 'none'
//           }}
//         >
//           <Typography
//             id="message-modal-title"
//             variant={isMobile ? 'subtitle1' : 'h6'}
//             component="h2"
//           >
//             Send Message
//           </Typography>
//           <Typography
//             id="message-modal-description"
//             sx={{ mt: 2, fontSize: isMobile ? '0.875rem' : '1rem' }}
//           >
//             Sending message to {selectedWorker?.name}.
//           </Typography>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//             <Button
//               onClick={closeModals}
//               variant="contained"
//               size={isMobile ? 'small' : 'medium'}
//               sx={{
//                 textTransform: 'none',
//                 fontSize: isMobile ? '0.75rem' : '0.875rem'
//               }}
//             >
//               Close
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </ThemeProvider>
//   );
// };

// export default OfficeSupport;

// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { AppDispatch, RootState } from 'app/store';
// import {
//   fetchManagers,
//   clearManagers,
//   deleteManager,
//   removeManager
// } from '../../slices/NdisSlices/managersList/ManagersListSlice';
// import { Manager } from '../../types/ndisSection/managersListTypes';
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   IconButton,
//   Modal,
//   Typography,
//   useMediaQuery
// } from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import {
//   DataGrid,
//   GridColDef,
//   GridPaginationModel,
//   GridToolbarQuickFilter
// } from '@mui/x-data-grid';
// import { Message, Delete } from '@mui/icons-material';
// import { useClientContext } from './ProfileMainPage';
// import axiosInstance from 'Services/APIService';

// // Dynamic Columns based on screen size
// const getColumns = (isMobile: boolean, handleDelete: (email: string) => void): GridColDef[] => [
//   {
//     field: 'avatar',
//     headerName: isMobile ? '' : 'Image',
//     width: isMobile ? 50 : 80,
//     renderCell: (params) => (
//       <Avatar
//         src={params.row.avatarUrl}
//         alt={params.row.name}
//         sx={{
//           width: isMobile ? 32 : 40,
//           height: isMobile ? 32 : 40
//         }}
//       />
//     ),
//     sortable: false,
//     filterable: false,
//     hideable: isMobile
//   },
//   {
//     field: 'name',
//     headerName: 'Name',
//     flex: isMobile ? 1 : 2,
//     minWidth: isMobile ? 120 : 150,
//     sortable: true
//   },
//   {
//     field: 'email',
//     headerName: isMobile ? '' : 'Email',
//     flex: isMobile ? 0 : 2,
//     minWidth: isMobile ? 0 : 180,
//     sortable: !isMobile,
//     hideable: isMobile
//   },
//   {
//     field: 'actions',
//     headerName: 'Actions',
//     flex: isMobile ? 1 : 1,
//     minWidth: isMobile ? 120 : 180,
//     renderCell: (params) => (
//       <Box sx={{ display: 'flex', gap: 1 }}>
//         <Button
//           variant="outlined"
//           color="primary"
//           startIcon={isMobile ? null : <Message />}
//           size={isMobile ? 'small' : 'medium'}
//           sx={{
//             textTransform: 'none',
//             fontSize: isMobile ? '0.75rem' : '0.875rem',
//             minWidth: isMobile ? 60 : 'auto',
//             padding: isMobile ? '4px 8px' : '6px 16px'
//           }}
//           onClick={() => params.row.handleMessageClick(params.row)}
//         >
//           {isMobile ? 'Msg' : 'Message'}
//         </Button>
//         <IconButton
//           color="error"
//           size={isMobile ? 'small' : 'medium'}
//           onClick={() => handleDelete(params.row.email)}
//           sx={{
//             fontSize: isMobile ? '0.75rem' : '0.875rem',
//             padding: isMobile ? '4px' : '8px'
//           }}
//         >
//           <Delete fontSize={isMobile ? 'small' : 'medium'} />
//         </IconButton>
//       </Box>
//     ),
//     sortable: false,
//     filterable: false
//   }
// ];

// // Responsive Toolbar
// function CustomToolbar({ isMobile }: { isMobile: boolean }) {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 1,
//         p: 1,
//         bgcolor: 'background.paper',
//         borderBottom: '1px solid #e0e0e0'
//       }}
//     >
//       <Typography
//         variant={isMobile ? 'subtitle1' : 'h6'}
//         sx={{
//           fontWeight: 'bold',
//           textAlign: 'center',
//           fontSize: isMobile ? '1rem' : '1.25rem'
//         }}
//       >
//         Office Support Directory
//       </Typography>
//       <Box sx={{ width: '100%' }}>
//         <GridToolbarQuickFilter
//           placeholder={isMobile ? 'Search...' : 'Search office support...'}
//           debounceMs={500}
//           quickFilterParser={(value) => value.split(' ')}
//           sx={{
//             width: '100%',
//             '& .MuiInputBase-root': {
//               borderRadius: '4px',
//               paddingLeft: '12px',
//               bgcolor: '#f4f4f4',
//               border: '1px solid #d6d6d6',
//               height: isMobile ? '36px' : 'auto'
//             },
//             '& .MuiInputBase-input': {
//               fontSize: isMobile ? '0.875rem' : '1rem'
//             }
//           }}
//         />
//       </Box>
//     </Box>
//   );
// }

// const OfficeSupport: React.FC = () => {
//   const dispatch = useDispatch<AppDispatch>();
//   const { selectedClient } = useClientContext();
//   const isMobile = useMediaQuery('(max-width:600px)');
//   const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
//     page: 0,
//     pageSize: isMobile ? 5 : 10
//   });
//   const [messageModalOpen, setMessageModalOpen] = useState(false);
//   const [selectedWorker, setSelectedWorker] = useState<Manager | null>(null);
//   const [avatarUrls, setAvatarUrls] = useState<{ [key: string]: string | null }>({});

//   // Redux state
//   const officeSupport = useSelector(
//     (state: RootState) => state.managersList.fullStaff?.participants_list['Office support'] || []
//   );
//   const loading = useSelector((state: RootState) => state.managersList.loading);
//   const error = useSelector((state: RootState) => state.managersList.error);
//   const selectedProjectId = useSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const userDetails = localStorage.getItem('user-details');
//   const parsedUserDetails = userDetails ? JSON.parse(userDetails) : null;
//   const email = parsedUserDetails?.email || '';
//   const roles = parsedUserDetails?.role ? [parsedUserDetails.role] : [''];

//   const handleDelete = async (staffEmail: string) => {
//     if (!selectedClient || !selectedProjectId || !selectedServiceTitle) return;

//     try {
//       await dispatch(
//         deleteManager({
//           group_id: selectedProjectId,
//           service_name_id: selectedServiceTitle,
//           staff_email: staffEmail,
//           client_email: selectedClient.email
//         })
//       ).unwrap();

//       // Remove the worker from the local state immediately
//       dispatch(removeManager(staffEmail));
//     } catch (error) {
//       console.error('Failed to delete office support worker:', error);
//     }
//   };

//   // Fetch avatars for all office support workers
//   useEffect(() => {
//     const fetchAvatars = async () => {
//       const newAvatarUrls: { [key: string]: string | null } = {};
//       for (const worker of officeSupport) {
//         if (worker.avartar) {
//           try {
//             const response = await axiosInstance.get(
//               `/avatar/get-avatar?path=${encodeURIComponent(worker.avartar)}`,
//               { responseType: 'blob' }
//             );
//             const imageUrl = URL.createObjectURL(response.data);
//             newAvatarUrls[worker.id] = imageUrl;
//           } catch (error) {
//             console.error(`Error fetching avatar for ${worker.name}:`, error);
//             newAvatarUrls[worker.id] = null;
//           }
//         } else {
//           newAvatarUrls[worker.id] = null;
//         }
//       }
//       setAvatarUrls(newAvatarUrls);
//     };

//     if (officeSupport.length > 0) {
//       fetchAvatars();
//     }

//     // Cleanup object URLs to prevent memory leaks
//     return () => {
//       Object.values(avatarUrls).forEach((url) => {
//         if (url) {
//           URL.revokeObjectURL(url);
//         }
//       });
//     };
//   }, [officeSupport]);

//   const handleMessageClick = (worker: Manager) => {
//     setSelectedWorker(worker);
//     setMessageModalOpen(true);
//   };

//   const closeModals = () => {
//     setMessageModalOpen(false);
//     setSelectedWorker(null);
//   };

//   // Fetch data when dependencies change
//   useEffect(() => {
//     if (selectedClient && selectedProjectId && selectedServiceTitle && email && roles.length > 0) {
//       const payload = {
//         group_id: selectedProjectId,
//         service_name_id: selectedServiceTitle,
//         nested_component_id: 'Office Support',
//         email,
//         roles,
//         client_name: selectedClient.label
//       };
//       dispatch(fetchManagers(payload));
//     }
//     return () => {
//       dispatch(clearManagers());
//     };
//   }, [selectedClient?.label]);

//   // Prepare rows with avatar URLs and handler function
//   const rows = officeSupport.map((worker) => ({
//     ...worker,
//     avatarUrl: avatarUrls[worker.id] || null,
//     handleMessageClick
//   }));

//   const theme = createTheme({
//     palette: {
//       primary: { main: '#2196f3' },
//       background: { default: '#f5f5f5', paper: '#ffffff' }
//     },
//     typography: {
//       fontFamily: 'Roboto, Arial',
//       fontSize: isMobile ? 12 : 14
//     },
//     components: {
//       MuiButton: {
//         defaultProps: {
//           size: isMobile ? 'small' : 'medium'
//         }
//       }
//     }
//   });

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: isMobile ? 'calc(100vh - 120px)' : 700,
//           width: '100%',
//           bgcolor: 'background.default',
//           p: isMobile ? 1 : 3,
//           borderRadius: 2,
//           boxShadow: 1,
//           overflow: 'hidden'
//         }}
//       >
//         {loading && (
//           <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//             <CircularProgress size={isMobile ? 24 : 40} />
//           </Box>
//         )}
//         {error && (
//           <Alert severity="error" sx={{ mb: 2, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
//             {error}
//           </Alert>
//         )}
//         {!selectedClient && (
//           <Alert severity="warning" sx={{ mb: 2, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
//             Please select a client to view office support.
//           </Alert>
//         )}
//         {selectedClient && !loading && (
//           <DataGrid
//             rows={rows}
//             columns={getColumns(isMobile, handleDelete)}
//             getRowId={(row) => row.id}
//             components={{ Toolbar: () => <CustomToolbar isMobile={isMobile} /> }}
//             checkboxSelection={false}
//             pagination
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={isMobile ? [5, 10] : [10, 25, 50]}
//             sx={{
//               '& .MuiDataGrid-columnHeaders': {
//                 bgcolor: '#f4f4f4',
//                 color: '#333',
//                 fontSize: isMobile ? '0.75rem' : '0.875rem',
//                 fontWeight: 'bold'
//               },
//               '& .MuiDataGrid-row:nth-of-type(odd)': {
//                 bgcolor: '#fafafa'
//               },
//               '& .MuiDataGrid-row:nth-of-type(even)': {
//                 bgcolor: '#ffffff'
//               },
//               '& .MuiDataGrid-row:hover': {
//                 bgcolor: '#e3f2fd'
//               },
//               '& .MuiDataGrid-cell': {
//                 fontSize: isMobile ? '0.75rem' : '0.875rem',
//                 padding: isMobile ? '4px 8px' : '8px 16px'
//               },
//               '& .MuiDataGrid-footerContainer': {
//                 bgcolor: '#f4f4f4',
//                 borderTop: '1px solid #e0e0e0',
//                 '& .MuiTablePagination-root': {
//                   fontSize: isMobile ? '0.75rem' : '0.875rem'
//                 }
//               },
//               '& .MuiDataGrid-virtualScroller': {
//                 overflowX: 'hidden'
//               }
//             }}
//           />
//         )}
//       </Box>

//       <Modal
//         open={messageModalOpen}
//         onClose={closeModals}
//         aria-labelledby="message-modal-title"
//         aria-describedby="message-modal-description"
//       >
//         <Box
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: isMobile ? '90%' : 400,
//             bgcolor: 'background.paper',
//             p: isMobile ? 2 : 4,
//             boxShadow: 24,
//             borderRadius: 2,
//             outline: 'none'
//           }}
//         >
//           <Typography
//             id="message-modal-title"
//             variant={isMobile ? 'subtitle1' : 'h6'}
//             component="h2"
//           >
//             Send Message
//           </Typography>
//           <Typography
//             id="message-modal-description"
//             sx={{ mt: 2, fontSize: isMobile ? '0.875rem' : '1rem' }}
//           >
//             Sending message to {selectedWorker?.name}.
//           </Typography>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//             <Button
//               onClick={closeModals}
//               variant="contained"
//               size={isMobile ? 'small' : 'medium'}
//               sx={{
//                 textTransform: 'none',
//                 fontSize: isMobile ? '0.75rem' : '0.875rem'
//               }}
//             >
//               Close
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </ThemeProvider>
//   );
// };

// export default OfficeSupport;

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'app/store';
import {
  fetchManagers,
  clearManagers,
  deleteManager,
  removeManager
} from '../../slices/NdisSlices/managersList/ManagersListSlice';
import { Manager } from '../../types/ndisSection/managersListTypes';
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  DataGrid,
  GridColDef,
  GridPaginationModel,
  GridToolbarQuickFilter
} from '@mui/x-data-grid';
import { Message, Delete } from '@mui/icons-material';
import { useClientContext } from './ProfileMainPage';
import axiosInstance from 'Services/APIService';

// Dynamic Columns based on screen size
const getColumns = (
  isMobile: boolean,
  handleDeleteClick: (email: string) => void
): GridColDef[] => [
  {
    field: 'avatar',
    headerName: isMobile ? '' : 'Image',
    width: isMobile ? 50 : 80,
    renderCell: (params) => (
      <Avatar
        src={params.row.avatarUrl}
        alt={params.row.name}
        sx={{
          width: isMobile ? 32 : 40,
          height: isMobile ? 32 : 40
        }}
      />
    ),
    sortable: false,
    filterable: false,
    hideable: isMobile
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: isMobile ? 1 : 2,
    minWidth: isMobile ? 120 : 150,
    sortable: true
  },
  {
    field: 'email',
    headerName: isMobile ? '' : 'Email',
    flex: isMobile ? 0 : 2,
    minWidth: isMobile ? 0 : 180,
    sortable: !isMobile,
    hideable: isMobile
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: isMobile ? 1 : 1,
    minWidth: isMobile ? 120 : 180,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={isMobile ? null : <Message />}
          size={isMobile ? 'small' : 'medium'}
          sx={{
            textTransform: 'none',
            fontSize: isMobile ? '0.75rem' : '0.875rem',
            minWidth: isMobile ? 60 : 'auto',
            padding: isMobile ? '4px 8px' : '6px 16px'
          }}
          onClick={() => params.row.handleMessageClick(params.row)}
        >
          {isMobile ? 'Msg' : 'Message'}
        </Button>
        <IconButton
          color="error"
          size={isMobile ? 'small' : 'medium'}
          onClick={() => handleDeleteClick(params.row.email)}
          sx={{
            fontSize: isMobile ? '0.75rem' : '0.875rem',
            padding: isMobile ? '4px' : '8px'
          }}
        >
          <Delete fontSize={isMobile ? 'small' : 'medium'} />
        </IconButton>
      </Box>
    ),
    sortable: false,
    filterable: false
  }
];

// Responsive Toolbar
function CustomToolbar({ isMobile }: { isMobile: boolean }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 1,
        bgcolor: 'background.paper',
        borderBottom: '1px solid #e0e0e0'
      }}
    >
      <Typography
        variant={isMobile ? 'subtitle1' : 'h6'}
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: isMobile ? '1rem' : '1.25rem'
        }}
      >
        Office Support Directory
      </Typography>
      <Box sx={{ width: '100%' }}>
        <GridToolbarQuickFilter
          placeholder={isMobile ? 'Search...' : 'Search office support...'}
          debounceMs={500}
          quickFilterParser={(value) => value.split(' ')}
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              borderRadius: '4px',
              paddingLeft: '12px',
              bgcolor: '#f4f4f4',
              border: '1px solid #d6d6d6',
              height: isMobile ? '36px' : 'auto'
            },
            '& .MuiInputBase-input': {
              fontSize: isMobile ? '0.875rem' : '1rem'
            }
          }}
        />
      </Box>
    </Box>
  );
}

const OfficeSupport: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedClient } = useClientContext();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: isMobile ? 5 : 10
  });
  const [messageModalOpen, setMessageModalOpen] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [workerToDelete, setWorkerToDelete] = useState<string | null>(null);
  const [selectedWorker, setSelectedWorker] = useState<Manager | null>(null);
  const [avatarUrls, setAvatarUrls] = useState<{ [key: string]: string | null }>({});

  // Redux state
  const officeSupport = useSelector(
    (state: RootState) => state.managersList.fullStaff?.participants_list['Office support'] || []
  );
  const loading = useSelector((state: RootState) => state.managersList.loading);
  const error = useSelector((state: RootState) => state.managersList.error);
  const selectedProjectId = useSelector(
    (state: RootState) => state.homeTilesServices.selectedProjectId
  );
  const selectedServiceTitle = useSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle
  );
  const userDetails = localStorage.getItem('user-details');
  const parsedUserDetails = userDetails ? JSON.parse(userDetails) : null;
  const email = parsedUserDetails?.email || '';
  const roles = parsedUserDetails?.role ? [parsedUserDetails.role] : [''];

  const handleDeleteClick = (staffEmail: string) => {
    setWorkerToDelete(staffEmail);
    setDeleteConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!workerToDelete || !selectedClient || !selectedProjectId || !selectedServiceTitle) return;

    try {
      await dispatch(
        deleteManager({
          group_id: selectedProjectId,
          service_name_id: selectedServiceTitle,
          staff_email: workerToDelete,
          client_email: selectedClient.email
        })
      ).unwrap();

      // Refresh the list after successful deletion
      const payload = {
        group_id: selectedProjectId,
        service_name_id: selectedServiceTitle,
        nested_component_id: 'Office Support',
        email,
        roles,
        client_name: selectedClient.label
      };
      await dispatch(fetchManagers(payload));
    } catch (error) {
      console.error('Failed to delete office support worker:', error);
    } finally {
      setDeleteConfirmOpen(false);
      setWorkerToDelete(null);
    }
  };

  useEffect(() => {
    const fetchAvatars = async () => {
      const newAvatarUrls: { [key: string]: string | null } = {};
      for (const worker of officeSupport) {
        if (worker.avartar) {
          try {
            const response = await axiosInstance.get(
              `/avatar/get-avatar?path=${encodeURIComponent(worker.avartar)}`,
              { responseType: 'blob' }
            );
            const imageUrl = URL.createObjectURL(response.data);
            newAvatarUrls[worker.id] = imageUrl;
          } catch (error) {
            console.error(`Error fetching avatar for ${worker.name}:`, error);
            newAvatarUrls[worker.id] = null;
          }
        } else {
          newAvatarUrls[worker.id] = null;
        }
      }
      setAvatarUrls(newAvatarUrls);
    };

    if (officeSupport.length > 0) {
      fetchAvatars();
    }

    // Cleanup object URLs to prevent memory leaks
    return () => {
      Object.values(avatarUrls).forEach((url) => {
        if (url) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [officeSupport]);

  const handleMessageClick = (worker: Manager) => {
    setSelectedWorker(worker);
    setMessageModalOpen(true);
  };

  const closeModals = () => {
    setMessageModalOpen(false);
    setSelectedWorker(null);
  };

  // Fetch data when dependencies change
  useEffect(() => {
    const fetchData = async () => {
      if (
        selectedClient &&
        selectedProjectId &&
        selectedServiceTitle &&
        email &&
        roles.length > 0
      ) {
        const payload = {
          group_id: selectedProjectId,
          service_name_id: selectedServiceTitle,
          nested_component_id: 'Office Support',
          email,
          roles,
          client_name: selectedClient.label
        };
        await dispatch(fetchManagers(payload));
      }
    };

    fetchData();

    return () => {
      dispatch(clearManagers());
    };
  }, [selectedClient]);

  // Prepare rows with avatar URLs and handler function
  const rows = officeSupport.map((worker) => ({
    ...worker,
    avatarUrl: avatarUrls[worker.id] || null,
    handleMessageClick
  }));

  const theme = createTheme({
    palette: {
      primary: { main: '#2196f3' },
      error: { main: '#f44336' },
      background: { default: '#f5f5f5', paper: '#ffffff' }
    },
    typography: {
      fontFamily: 'Roboto, Arial',
      fontSize: isMobile ? 12 : 14
    },
    components: {
      MuiButton: {
        defaultProps: {
          size: isMobile ? 'small' : 'medium'
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: isMobile ? 'calc(100vh - 120px)' : 700,
          width: '100%',
          bgcolor: 'background.default',
          p: isMobile ? 1 : 3,
          borderRadius: 2,
          boxShadow: 1,
          overflow: 'hidden'
        }}
      >
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CircularProgress size={isMobile ? 24 : 40} />
          </Box>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
            {error}
          </Alert>
        )}
        {!selectedClient && (
          <Alert severity="warning" sx={{ mb: 2, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
            Please select a client to view office support.
          </Alert>
        )}
        {selectedClient && !loading && !error && (
          <DataGrid
            rows={rows}
            columns={getColumns(isMobile, handleDeleteClick)}
            getRowId={(row) => row.id}
            components={{ Toolbar: () => <CustomToolbar isMobile={isMobile} /> }}
            checkboxSelection={false}
            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={isMobile ? [5, 10] : [10, 25, 50]}
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                bgcolor: '#f4f4f4',
                color: '#333',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                fontWeight: 'bold'
              },
              '& .MuiDataGrid-row:nth-of-type(odd)': {
                bgcolor: '#fafafa'
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                bgcolor: '#ffffff'
              },
              '& .MuiDataGrid-row:hover': {
                bgcolor: '#e3f2fd'
              },
              '& .MuiDataGrid-cell': {
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                padding: isMobile ? '4px 8px' : '8px 16px'
              },
              '& .MuiDataGrid-footerContainer': {
                bgcolor: '#f4f4f4',
                borderTop: '1px solid #e0e0e0',
                '& .MuiTablePagination-root': {
                  fontSize: isMobile ? '0.75rem' : '0.875rem'
                }
              },
              '& .MuiDataGrid-virtualScroller': {
                overflowX: 'hidden'
              }
            }}
          />
        )}
      </Box>

      <Modal
        open={messageModalOpen}
        onClose={closeModals}
        aria-labelledby="message-modal-title"
        aria-describedby="message-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isMobile ? '90%' : 400,
            bgcolor: 'background.paper',
            p: isMobile ? 2 : 4,
            boxShadow: 24,
            borderRadius: 2,
            outline: 'none'
          }}
        >
          <Typography
            id="message-modal-title"
            variant={isMobile ? 'subtitle1' : 'h6'}
            component="h2"
          >
            Send Message
          </Typography>
          <Typography
            id="message-modal-description"
            sx={{ mt: 2, fontSize: isMobile ? '0.875rem' : '1rem' }}
          >
            Sending message to {selectedWorker?.name}.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              onClick={closeModals}
              variant="contained"
              size={isMobile ? 'small' : 'medium'}
              sx={{
                textTransform: 'none',
                fontSize: isMobile ? '0.75rem' : '0.875rem'
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this office support worker?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)}>Cancel</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default OfficeSupport;